export const getKey =
  (edges = []) =>
  key =>
    edges.find(({ node }) => node.key === key)?.node
export const getMeta =
  (list = []) =>
  keyExternal =>
    list.find(({ key }) => key === keyExternal)
